import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { filterActions } from '../../behavior/filter/index';
import BuildingSummaryOverviewTableForm from './BuildingSummaryOverviewTableForm';
import FilteringContextProvider from '../Filtering/FilteringContextProvider';

const BuildingSummaryOverviewTableContainer = ({
  actions,
  allFilters,
  entityType,
  tableOptions,
  showBackendSwitch,
  defaultFilteredList,
  hazardList,
  buildingNum
}) => {
  useEffect(() => {
    actions.initializeFiltering(entityType);
  }, []);

  const filterProps = allFilters[entityType] || {};

  return filterProps.possibleFieldsList &&
    filterProps.possibleFieldsList.length > 0 &&
    filterProps.visibleFieldsList.length > 0 &&
    filterProps.visibleColumnsList.length > 0 &&
    filterProps.visibleColumnsList.length > 0 ? (
    <FilteringContextProvider
      visibleColumns={filterProps.visibleColumnsList}
      visibleFields={filterProps.visibleFieldsList}
      actions={actions}
      entityType={entityType}
      tableOptions={tableOptions}
      showBackendSwitch={showBackendSwitch}
      filterProps={filterProps}
      defaultFilteredList={defaultFilteredList}
      hazardList={hazardList}
      buildingNum={buildingNum}
      selectedRows={{}}
    >
      <BuildingSummaryOverviewTableForm />
    </FilteringContextProvider>
  ) : null;
};

BuildingSummaryOverviewTableContainer.propTypes = {
  actions: PropTypes.shape({
    initializeFiltering: PropTypes.func.isRequired,
    applyFilterAction: PropTypes.func.isRequired
  }).isRequired,
  allFilters: PropTypes.object.isRequired,
  entityType: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  tableOptions: PropTypes.array,
  showBackendSwitch: PropTypes.bool,
  hazardList: PropTypes.array
};

BuildingSummaryOverviewTableContainer.defaultProps = {
  tableOptions: [],
  showBackendSwitch: false,
  hazardList: []
};

const mapStateToProps = state => ({
  allFilters: state.filter
});

const mapDispatchToProps = dispatch => ({
  actions: {
    initializeFiltering: entityType => dispatch(filterActions.initializeFiltering(entityType)),
    applyFilterAction: (entityType, filterState, filters) =>
      dispatch(filterActions.applyFilterV2(entityType, filterState, filters))
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(BuildingSummaryOverviewTableContainer);
